import API from '../../services/api.svelte.js';

export const fetchAssets = (resource = "v2/asset/", config = {}) => {
    return API.search(resource, config);
};

export const findAsset = (id, config = {}) => {
    return API.find('v2/asset', id, config)
};

export const saveAsset = (data, config = {}, is_upsert = false) => {
    return API.save("v2/asset", data, [], config, is_upsert);
};

export const deleteAssets = (asset_ids = [], config = {}) => {
    return API.del('v2/asset/', asset_ids, config);
}

export const fetchAssetsCountByKind = (config = {}) => {
    return API.search("v2/asset/count_by_kind/", config);
};

export const fetchAssetsProperties = async (config = { filter: {} }) => {
    return API.search('v2/asset-property/', config);
}

export const fetchAssetsPropertiesCount = async (config = { filter: {} }) => {
    return API.search("v2/asset-property/count/", config);
}

export const fetchAssetsPropertiesCountByKind = async (config = { filter: {} }) => {
    return API.search("v2/asset-property/count_by_kind/", config);
}

export const fetchAssetsRelations = async (config = { filter: {} }) => {
    return API.search('v2/asset-relation/', config);
}

export const fetchAssetRelations = async (asset_id, config = {filter: {}}) => {
    if(config && config.filter){
        config.filter.related_asset_id = asset_id;
    }
    else {
        config = {filter:{related_asset_id: asset_id}}
    }
    return API.search('v2/asset/', config);
}

export function sortGroupedPorts(ports){
    ports = ports.sort((a,b)=>{
        let firstPortSplited = a[0] ? a[0].split("/") : a.split("/");
        let secondPortSplited = b[0] ? b[0].split("/"): b.split("/");
        let text_a = firstPortSplited[0];
        let text_b = secondPortSplited[0];
        let num_a = parseInt(firstPortSplited[1]);
        let num_b = parseInt(secondPortSplited[1]);
        return (text_a.localeCompare(text_b) == 0) ? (num_a > num_b) ? 1 : -1 : (text_a.localeCompare(text_b))
    });
    return ports;
}

export function is_ip_list(kind, checkKind){
    if(checkKind){
        return {
            private: kind.includes("private_ip"),
            public: kind.includes("public_ip"),
        }
    }
    return kind.includes("_ip");
};

export function is_hostname_list(kind){
    return kind.includes("hostname");
};

export function is_domain_list(kind){
   return kind.includes("domain");
}

//icons
export const AssetsIcons = {
    domain: 'fas fa-globe',
    hostname: 'fas fa-laptop-code',
    public_network: 'fas fa-network-wired',
    private_network: 'fas fa-network-wired',
    public_ip: 'fas fa-laptop',
    private_ip: 'fas fa-laptop',
    certificate: 'fas fa-lock',
    ad: 'fas fa-address-book',
    cloud: 'fas fa-cloud',
    software: 'fas fa-code-branch',
    endpoint: 'fas fa-project-diagram',
    email: 'fas fa-envelope',
    container_image: 'fab fa-docker',
}

//translations
export const AssetsTranslations = {
    plural: {
        domain: 'Dominios',
        hostname: 'Hostnames',
        public_network: 'Redes públicas',
        private_network: 'Redes privadas',
        public_ip: 'Direcciones IP Públicas',
        private_ip: 'Direcciones IP Privadas',
        certificate: 'Certificados',
        ad: 'Active Directory',
        cloud: 'Cuentas cloud',
        software: 'Software',
        endpoint: 'Endpoint',
        email: 'Emails',
        container_image: 'Imágenes de contenedores'
    },
    singular: {
        domain: 'Dominio',
        hostname: 'Hostname',
        public_network: 'Red pública',
        private_network: 'Red privada',
        public_ip: 'IP Pública',
        private_ip: 'IP Privada',
        certificate: 'Certificado',
        ad: 'Active Directory',
        cloud: 'Cuenta cloud',
        software: 'Software',
        endpoint: 'Endpoint',
        email: 'Email',
        container_image: 'Imagen de contenedor',
    }
}
//known_kinds
export const assets_kinds = [
    {id: "domain", name: "Dominio"},
    {id: "hostname", name: "Hostname"},
    {id: "public_network", name: "Red Pública"},
    {id: "private_network", name: "Red Privada"},
    {id: "public_ip", name: "IP pública"},
    {id: "private_ip", name: "IP privada"},
    {id: "ad", name: "Active Directory"},
    {id: "cloud", name: "Cuenta cloud"},
    {id: "software", name: "Software"},
    {id: "endpoint", name: "Endpoint"},
    {id: "email", name: "Email"},
    {id: "container_image", name: "Imagen de contenedor"},
]

export const os_icons = [
    {label: "linux", fileName: "linux.png", height: "24"},
    {label: "microsoft", fileName: "microsoft.png", height: "24"},
    {label: "amazon", fileName: "amazon.png", height: "24"},
    {label: "vxworks", fileName: "vxworks.svg", height: "24"},
    {label: "paloalto", fileName: "paloalto.svg", height: "24"},
    {label: "vmware", fileName: "VMware.png", height: "24"},
    {label: "apple", fileName: "apple.png", height: "24"},
    {label: "cisco", fileName: "cisco.png", height: "24"},
    {label: "dell", fileName: "dell.png", height: "24"},
    {label: "fortinet", fileName: "fortinet.svg", height: "48"},
    {label: "hikvision", fileName: "hikvision.png", height: "24"},
    {label: "huawei", fileName: "huawei.png", height: "24"},
    {label: "mikrotik", fileName: "mikrotik.png", height: "24"},
    {label: "motorola", fileName: "motorola.png", height: "24"},
    {label: "unraid", fileName: "unraid.png", height: "24"},
    {label: "apc", fileName: "apc.svg", height: "24"},
    {label: "xerox", fileName: "xerox.png", height: "36"},
    {label: "samsung", fileName: "samsung.png", height: "16"},
    {label: "hp", fileName: "hp.png", height: "24"},
    {label: "extreme", fileName: "extreme.jpeg", height: "24"}

];

export default {
    fetchAssets,
    findAsset,
    saveAsset,
    deleteAssets,
    fetchAssetsProperties,
    fetchAssetsPropertiesCount,
    fetchAssetsPropertiesCountByKind,
    fetchAssetsRelations,
    fetchAssetRelations,
    sortGroupedPorts,
    is_ip_list,
    is_hostname_list,
    is_domain_list,
    AssetsIcons,
    AssetsTranslations,
    assets_kinds,
    os_icons
}